import React, { Fragment } from 'react';
import { List } from 'antd';
import Item from './Item';

export default function PlaceList({ data, total, className }) {
  return (
    <Fragment>
      <h3>Places ({total || (Array.isArray(data) && data.length)})</h3>
      <List
        className={className}
        grid={{
          gutter: 8,
        }}
        dataSource={data}
        renderItem={(place) => (
          <List.Item>
            <Item place={place} />
          </List.Item>
        )}
      />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/List/index.js